import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import PostListCard from 'src/modules/community/shared/components/sidebar/postListCard';

const CommunityPostsPopularPosts = ({ community, posts }) => (
  <PostListCard
    community={community}
    posts={posts}
    postType={'popular-post'}
    title={i18n.t('Popular Posts')}
  />
);

CommunityPostsPopularPosts.propTypes = {
  community: PropTypes.object.isRequired,
  posts: PropTypes.array.isRequired,
};

export default CommunityPostsPopularPosts;
